import React from "react";
import { FormFieldProps } from "./FormField";


const FormRow: React.FunctionComponent<Partial<FormFieldProps<any>>> = props => {
	const { children, ...other } = props;
	const newChildren = React.Children.map( children,
		child => {
			if ( child ) return React.cloneElement( child as React.ReactElement<any>, { ...other } );
			return child;
		} );
	return (
		<div className={ "row" }>
			{ newChildren }
		</div>
	);
};

export default FormRow;
